import type { ReactElement } from "react";

export const OnboardingHeading: (props: { merchant?: boolean; agent?: boolean; merchantType?: "director" | "brand" | null }) => ReactElement = () => {
  return <header className="rg-head"><h1 className="rg-title">注册并入驻 Mirafans 镜界</h1></header>;
};
